<!-- Annotation Targets Form -->
@if (annotationTargetsForm) {
  <medsurf-design-form-control-form
    [formGroup]="annotationTargetsForm"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div class="flex flex-column row-gap-2 align-items-center">
      <h4 class="uppercase align-self-start"
        translate="global.marker">
      </h4>
      <!-- Text Color -->
      <medsurf-design-form-control-input-color-picker [control]="annotationTargetsForm.controls.color"
        [class]="'w-full'"
        [label]="'global.color'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
      <div class="flex flex-1 flex-row column-gap-2 w-full">
        <!-- End Type -->
        <medsurf-design-form-control-input-dropdown [control]="annotationTargetsForm.controls.endType"
          [class]="'w-full'"
          [options]="FlatModels.AnnotationEntityModels.TipTypeArray"
          [label]="'global.type'"
        (valueChange)="onEndTypeChange()"></medsurf-design-form-control-input-dropdown>
        <!-- Target Count -->
        <medsurf-design-form-control-input-number [control]="annotationTargetsForm.controls.targets"
          [class]="'w-full'"
          [min]="0"
          [max]="20"
          [label]="'global.quantity'"
        (valueChange)="onSubmit()"></medsurf-design-form-control-input-number>
      </div>
      <!-- End Radius -->
      <medsurf-design-form-control-input-slider [hidden]="annotationTargetsForm.value.endType !== FlatModels.AnnotationEntityModels.TipType.enum.circle"
        [control]="annotationTargetsForm.controls.endRadius"
        [class]="'w-full'"
        [min]="1"
        [max]="100"
        [label]="'global.circle_radius'"
      (valueChange)="onSubmit()"></medsurf-design-form-control-input-slider>
    </div>
  </medsurf-design-form-control-form>
}